import { render, staticRenderFns } from "./ServiceCoupons.vue?vue&type=template&id=30c0db1c&scoped=true&"
import script from "./ServiceCoupons.vue?vue&type=script&lang=js&"
export * from "./ServiceCoupons.vue?vue&type=script&lang=js&"
import style0 from "./ServiceCoupons.vue?vue&type=style&index=0&id=30c0db1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c0db1c",
  null
  
)

export default component.exports